import { bindable, ICustomElementViewModel } from 'aurelia';
import './db-filter.scss';

export class DbFilter implements ICustomElementViewModel {
    blogsSearchEvt: boolean = false;
    postLoading: boolean = false;
    blogsResults: boolean = false;
    @bindable searchQuery: string = '';
    @bindable blogposts: any[] = [];
    @bindable sortItems: any[] = [];
    @bindable categories: any[] = [];
    @bindable sortBy: string = '';
    @bindable blogRoute: string = '';
    @bindable parent: any;

    async changeSelectHandler(event) {
        if (this.parent && typeof this.parent.changeSelectHandler === 'function') {
            await this.parent.changeSelectHandler(event);
        }
    }

    async functionTrigger() {
        if (this.parent && typeof this.parent.changeSelectHandler === 'function') {
            await this.parent.changeSelectHandler();
        }
    }

    async tagClickHandler(tag) {
        if (this.parent && typeof this.parent.tagClickHandler === 'function') {
            await this.parent.tagClickHandler(tag);
        }
    }
}
